import "./ExcelNoticeCards.css";

export default function ExcelErrorsCard({ errors = [] }) {
  if (!errors.length) return null;

  return (
    <section className="excel-notice-card excel-notice-card--error">
      <h3>Blokkerende fouten</h3>
      <p>Deze fouten moeten opgelost worden voordat import mogelijk is.</p>

      <div className="excel-notice-card__list">
        {errors.map((error, index) => (
          <div key={index} className="excel-notice-card__item">
            <strong>{error.type || "Fout"}</strong>
            <span>{error.message || JSON.stringify(error)}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
